import Icon from 'veui/components/Icon'

Icon.register({
  'live-broadcast': {
    paths: [
      {
        d: 'M241 466.29V301.71c0-5.19 3.42-9.94 8.84-12.26a18.25 18.25 0 0116.76 1.29l128 82.26a12.6 12.6 0 010 21.94l-128 82.29A17.84 17.84 0 01257 480a18.25 18.25 0 01-7.16-1.45c-5.42-2.32-8.84-7.07-8.84-12.26zM736 192v384a32 32 0 01-44 29.65l-116-47.11V640a32 32 0 01-32 32H64a32 32 0 01-32-32V128a32 32 0 0132-32h480a32 32 0 0132 32v81.46l116-47.11A32 32 0 01736 192zm-224-32H96v448h416zm160 79.54l-96 39v210.92l96 39V239.54z'
      }
    ],
    width: '768',
    height: '768'
  }
})
